import React from "react";

const TagCards = ({ 
  data, 
  themeColor, 
  children 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 h-32 flex flex-col justify-between">
      <h3 className="text-lg font-mediym" style={{ color: themeColor }}>
        {data.name}
      </h3>

      <div className="flex items-baseline justify-between w-full">
        <span className="text-4xl font-bold" style={{ color: themeColor }}>
          {data.count}
        </span>
        <span className="text-xl" style={{ color: themeColor }}>
          / {data.total}
        </span>
      </div>

      {children && (
        <div className="mt-1">
          {children(data)}
        </div>
      )}
    </div>
  );
};

export default TagCards;
